// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t3EMi","footer":"styles_footer__1-Qs1","passCodeTooltip":"styles_passCodeTooltip__3ehQd"};